import { Injectable, inject } from '@angular/core';
import {
  FileTypeDto,
  GeneralService,
  HelpRequestDto,
  HelpResponseDto,
  VersionDto,
} from '../../../api-main';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiMainGeneralService {
  private mainGeneralService = inject(GeneralService);
  private http = inject(HttpClient);

  constructor() {
    this.mainGeneralService = new GeneralService(
      this.http,
      ConfigService.getApiConfig(),
      undefined,
    );
  }

  public getHelp(helpRequest: HelpRequestDto): Observable<HelpResponseDto> {
    return this.mainGeneralService.generalControllerGetHelp(helpRequest);
  }

  public getImage(imagePath: string): Observable<FileTypeDto> {
    return this.mainGeneralService.generalControllerGetImage(imagePath);
  }

  public getVersion(): Observable<VersionDto> {
    return this.mainGeneralService.generalControllerGetVersion();
  }
}
